import React from 'react'
import McAfeeFooter from '../../components/docomo/McAfeeFooter.js'
import McAfeeHeader from '../../components/docomo/McAfeeHeader.js'
import { 
    Card, 
    Col,
    Row,
    Grid,
    Body 
} from '@mcafee/pegasus'
import '../../index.css';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { HTTPStatus } from '../../utils/enum.js';

export default function SupportIdPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { supportId, cust_context_id, signedAt,signedCCID } = location.state || {};
    const [isDisabled, setIsDisabled] = React.useState(false);

    const handleMyAccountClick = async () => {
          try {
            setIsDisabled(true);
            const baseUrl = process.env.REACT_APP_PARTNER_PAGES_BACKEND_URL;
            const response = await axios.post(`${baseUrl}/docomo/samlsso`, {cust_context_id:  cust_context_id, signedAt: signedAt, signedCCID: signedCCID});
           
            if ((response.status === HTTPStatus.CREATED) && (response.data.data.status === HTTPStatus.CREATED)) {
                const { samlResponse, relayState, destinationUrl } = response.data.data;

                const form = document.createElement('form');
                form.method = 'POST';
                form.action = destinationUrl;

                [['SAMLResponse', samlResponse], ['RelayState', relayState]].forEach(([name, value]) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
            }else {
                navigate(`/Login?errorCode=${encodeURIComponent('M-000')}`);
            }
        } catch (error) {
            // Handle error in subscription creation
            console.error("Error calling saml sso:", error);
            // redirect to error page
            navigate(`/Login?errorCode=${encodeURIComponent('M-000')}`)
        } finally {
            setIsDisabled(false);
        }
    };

  return (
    <>
    <title>パソコン向けウイルス対策とインターネット セキュリティ | マカフィー</title>
        <div>
            <header className="App-header">
                <McAfeeHeader />
            </header>
            <main>
                <section>
                    <div className="bg-primary corner-xl bg-size-auto">
                        <Grid >
                            <Row center="xs">
                                <Col>
                                    <Card className="py-72" featured >
                                        <Grid>
                                            <Row center="xs" >
                                                <Col>
                                                    <Body level="1">
                                                        <div center="xs">
                                                            ログインしました。<br />
                                                            お客様のマカフィーサポートIDはこちらです。
                                                        </div> <br/>
                                                        <div center="xs">
                                                            {supportId}
                                                        </div> <br/>
                                                        <div className="flex align-items-center">
                                                            ※マカフィーへお問い合わせをする際に必要になります。
                                                        </div>
                                                    </Body>
                                                </Col>
                                            </Row>
                                            <Row center="xs">
                                                <Col>
                                                    <div className="py-48">
                                                        <input type="submit" value = "マイアカウントへ" className="btn-doc-MfeAccount" disabled={isDisabled} onClick={() => handleMyAccountClick()}/>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </Card>
                                </Col>
                                <Col></Col>
                            </Row>
                        </Grid>
                    </div>
                </section>
            </main>
            <br />
            <footer className="App-header pt-48">
                <McAfeeFooter />
            </footer>
          </div>
    </>
  )
}

